import NewsTimelinePosts from "./news-timeline-posts";

export default NewsTimelinePosts;